export default __webpack_public_path__ + "russia.758e01da.png";